import { render, staticRenderFns } from "./wig-associate-search.vue?vue&type=template&id=8b19e61a"
import script from "./wig-associate-search.vue?vue&type=script&lang=js"
export * from "./wig-associate-search.vue?vue&type=script&lang=js"
import style0 from "./wig-associate-search.vue?vue&type=style&index=0&id=8b19e61a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports